import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import AuthPage from "./pages/AuthPage";
import HomePage from "./pages/HomePage";
import { Loader2 } from "lucide-react";

function AuthGuard({ children }: { children: React.ReactNode }) {
	const { isAuthenticated, isLoading } = useAuth();

	if (isLoading) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-slate-900">
				<Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
			</div>
		);
	}

	if (!isAuthenticated) {
		return <Navigate to="/auth" replace />;
	}

	return <>{children}</>;
}

export default function App() {
	const { isAuthenticated, isLoading } = useAuth();

	if (isLoading) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-slate-900">
				<Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
			</div>
		);
	}

	return (
		<Routes>
			<Route
				path="/auth"
				element={
					isAuthenticated ? (
						<Navigate to="/" replace />
					) : (
						<AuthPage />
					)
				}
			/>
			<Route
				path="/"
				element={
					<AuthGuard>
						<HomePage />
					</AuthGuard>
				}
			/>
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
}
